import { render, staticRenderFns } from "./UserParamCreate.vue?vue&type=template&id=afb2a7ae&scoped=true"
import script from "./UserParamCreate.vue?vue&type=script&lang=js"
export * from "./UserParamCreate.vue?vue&type=script&lang=js"
import style0 from "./UserParamCreate.vue?vue&type=style&index=0&id=afb2a7ae&prod&lang=styl&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb2a7ae",
  null
  
)

export default component.exports